import React from 'react';
import { Container } from '@adobe/cq-react-editable-components';
import PropTypes from 'prop-types';

import { viewport, isMobile, isDesktopResolution, getUrlName, getFlowType } from '../../../common/Helpers/index';
import './creditStatus.css';
import MiniCart from '../../../common/MiniCart/redesign';
import { store } from '../../../../configureStore';
import * as constants from '../../../../utils/ProgressStep/constants';
import { checkCartidAndLQResponse } from '../../../common/Helpers/commonLog';
import { FWAContainer } from '../../../common/FWAContainer';
import { Row, Col } from '../../../common/Grid';
import { eventDispatcher } from '../../../common/Tagging/index';
import { getChannelId } from '../../../../services/HttpService';
import { callPerformanceMeasure } from '../../../common/Helpers/performanceMeasure';

export default class CreditStatus extends Container {
  constructor(props) {
    super(props);
    checkCartidAndLQResponse('creditStatus');
    this.type = viewport();
    this.handleLoad = this.handleLoad.bind(this);
  }

  componentDidMount() {
    const { processSteps } = store.getState();
    window.addEventListener('load', this.handleLoad);

    store.dispatch({ type: 'CEF_CREDIT_STATUS_ERROR', response: false, errorMessage: null });
    store.dispatch({ type: 'TAGGING_API_LOADED', response: false });
    store.dispatch({ type: 'API_LOADED', response: false });
    store.dispatch({ type: constants.UPDATE_CURRENT_VIEW, response: processSteps.CreditStatus });

    if (!this.props.creditStatusLanded) {
      this.props.landedStatusPage();
    }

    if (isMobile() && window.vzFlags?.miniCartApi) {
      this.props.getMiniCartAPI();
    } else {
      this.props.getCartDataFromApi('creditstatus');
    }
  }

  handleLoad = () => {
    const pageName = getUrlName(window.location.href);
    const markerValue = `${pageName}:ui:${getChannelId()}:${getFlowType()}:render`;

    if (window?.performance?.measure) {
      window.performance.measure(markerValue);
    }
  };

  componentWillUnmount() {
    window.removeEventListener('load', this.handleLoad);
  }

  componentDidUpdate() {
    if (!this.state.invokeTagging && this.props.cartDetails?.apiStatus === 'COMPLETED' && this.props.apiLoaded) {
      this.props.invokeTaggingAPI();
      store.dispatch({ type: 'API_LOADED', response: false });
      this.setState({ invokeTagging: true });
    }
    if (this.props.taggingApiLoaded && window.vzdl?.page?.name === 'creditstatus') {
      eventDispatcher('sendData', {
        name: '',
        svars: {
          evar22: 'credit status fail',
        },
      });
      store.dispatch({ type: 'TAGGING_API_LOADED', response: false });
    }
    if (document.readyState === 'complete') {
      callPerformanceMeasure();
    }
  }

  render() {
    const creditComponents = this.childComponents.filter(
      (item) => !(item.key.indexOf('/miniCartDueToday') >= 0 || item.key.indexOf('/miniCartDueMonthly') >= 0),
    );
    const miniCartComponents = this.childComponents.filter(
      (item) => item.key.indexOf('/miniCartDueToday') >= 0 || item.key.indexOf('/miniCartDueMonthly') >= 0,
    );
    return (
      <FWAContainer topBufferAuto enableLiveSupport title={this.props.title}>
        <Row>
          <Col colSizes={{ mobile: 4, tablet: 12, desktop: 8 }}>{creditComponents}</Col>
          <Col className={isMobile() ? '' : 'hideForMobile margin90 onlyTopMargin cartContainer'} colSizes={{ mobile: 0, tablet: 3, desktop: 4 }}>
            {isDesktopResolution() && (
              <MiniCart
                miniCartComponents={miniCartComponents}
                showCartStatus={(iscartVisibleVal) => this.props.showCart(iscartVisibleVal)}
                iscartVisible={this.props.cartDetails.isCartVisible}
              />
            )}
            {isDesktopResolution() && <div id="creditStatusCTA" />}
          </Col>
        </Row>
      </FWAContainer>
    );
  }
}

CreditStatus.propTypes = {
  creditHoldContent: PropTypes.object,
  validateOrder: PropTypes.object,
  currentView: PropTypes.object,
  history: PropTypes.object,
  securityDepositMessage: PropTypes.any,
  getValidateOrder: PropTypes.func,
  validatedHoldOrder: PropTypes.bool,
  resetOrderStatus: PropTypes.func,
  creditAppNum: PropTypes.string,
  creditStatusLanded: PropTypes.bool,
  landedStatusPage: PropTypes.func,
  invokeTaggingAPI: PropTypes.func,
};
